import React, { HTMLAttributes, FC } from 'react';

export type ContainerType = FC<HTMLAttributes<HTMLDivElement>>;

const Container: ContainerType = ({ children, ...others }) => (
  <div {...others}>{children}</div>
)

export default Container;